import { IDotsModalLocalization } from "dots-ui/dotsModal";

export const modalLocalization = (
  res: (textKey: string) => string,
): IDotsModalLocalization => {
  return {
    CloseBtn: res("button_Close"),
    ConfirmBtn: res("button_Confirm"),
    Modal_Btn_Info: res("button_Info"),
    Modal_Btn_Cancel: res("button_ConfirmModalCancel"),
    Modal_Btn_Confirm: res("button_ConfirmModalConfirm"),
    Modal_Title_Warning: res("title_Warning"),
    Modal_Title_Danger: res("title_Danger"),
    Modal_Title_Confirm: res("title_Confirm"),
    Modal_Title_Info: res("title_Info"),
  };
};
